import Timeline from '@/components/activity/timeline';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
    '/_app/$module_id/$entity_type_id/$entity_id/_tabs/overview/',
)({
    component: RouteComponent,
})

function RouteComponent() {
    const { entity_type_id, entity_id } = Route.useParams();



    return <>
        <div className="flex flex-row m-5 w-full">
            <Timeline entityType={entity_type_id} entityId={entity_id} />
        </div>
    </>
}
